"use client";
import Button from "@/components/primitives/button";
import Icon from "@/components/primitives/icon";
import { useLastUrl } from "@/utils/url";
import { useRouter } from "next-nprogress-bar";
import React from "react";

export default function BackButton({fallback}: {fallback?: string;}) {
  const router = useRouter();

  const handleBackClick = () => {
    const lastUrl = useLastUrl();
    if (lastUrl && (lastUrl.includes("moneyline.com") || lastUrl.includes("localhost:3000"))) {
      router.back();
    } else if (fallback) {
      router.push(fallback);
    }
  };
  return (
    <Button
      color="light"
      size="sm"
      variant="circle"
      onClick={handleBackClick}
    >
      <div className="flex gap-2 items-center px-1">
        <Icon name="arrow-left" size="sm" />
        <span className="text-title-sm-medium">Back</span>
      </div>
    </Button>
  );
}
